<template>
  <div class="home">
    <div class="homeBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="getData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="resetSearch">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="6">
          <span class="label">按季度/月</span>
          <el-switch v-model="dateSwitch" @change="getQuarter"></el-switch>
        </el-col>
        <el-col :span="8">
          <span v-if="dateSwitch" class="label">选择月份</span>
          <span v-else class="label">选择季度</span>
          <el-date-picker v-if="dateSwitch"
                          type="month"
                          v-model="dateSelect"
                          placeholder="选择月份">
          </el-date-picker>
          <el-select v-else v-model="dateSelect">
            <el-option :value="1" label="第一季度"></el-option>
            <el-option :value="2" label="第二季度"></el-option>
            <el-option :value="3" label="第三季度"></el-option>
            <el-option :value="4" label="第四季度"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">数据范围</span>
          <el-select multiple v-model="searchData.scopes" placeholder="数据范围" style="width: 300px">
            <el-option
              label="全部数据"
              value="all"
              @click.native="selectAll"
            />
            <el-option @click.native="selectSingle" v-for="item in dataRangeOptions" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="20">{{ reportName }}</el-col>
        <el-col :span="4">
          <!--          <el-button type="success" size="mini">导出为EXCEL</el-button>-->
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <div class="chartBox">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="box-card">
              <div class="title">得分情况</div>
              <div class="score">
                <div>
                  <span class="curScore">{{ curScore }}</span>
                  <span class="icon upIcon" v-if="curScore > preScore">
                  <i class="el-icon-top"></i>
                </span>
                  <span class="icon downIcon" v-if="curScore < preScore">
                  <i class="el-icon-bottom"></i>
                </span>
                </div>
                <div v-if="dateSwitch">上月<span class="preScore">{{ preScore }}</span></div>
                <div v-else>上季度<span class="preScore">{{ preScore }}</span></div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div class="title">得分趋势图</div>
              <div id="c1" class="c1"></div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div class="title">大项得分分析</div>
              <div class="bigScore">
                <div class="col1" v-if="dateSwitch">
                  <p>本月</p>
                  <p>上月</p>
                </div>
                <div class="col1" v-else>
                  <p>本季</p>
                  <p>上季</p>
                </div>
                <div class="col2">
                  <div class="curData">{{ bigScore.type1[0] }}</div>
                  <div>
                    <div class="icon upIcon" v-if="bigScore.type1[0] > bigScore.type1[1]">
                      <i class="el-icon-top"></i>
                    </div>
                    <div class="icon downIcon" v-if="bigScore.type1[0] < bigScore.type1[1]">
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                  <div class="preData">{{ bigScore.type1[1] }}</div>
                  <div class="type">视觉陈列</div>
                </div>
                <div class="col3">
                  <div class="curData">{{ bigScore.type2[0] }}</div>
                  <div>
                    <div class="icon upIcon" v-if="bigScore.type2[0] > bigScore.type2[1]">
                      <i class="el-icon-top"></i>
                    </div>
                    <div class="icon downIcon" v-if="bigScore.type2[0] < bigScore.type2[1]">
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                  <div class="preData">{{ bigScore.type2[1] }}</div>
                  <div class="type">营运</div>
                </div>
                <div class="col4">
                  <div class="curData">{{ bigScore.type3[0] }}</div>
                  <div>
                    <div class="icon upIcon" v-if="bigScore.type3[0] > bigScore.type3[1]">
                      <i class="el-icon-top"></i>
                    </div>
                    <div class="icon downIcon" v-if="bigScore.type3[0] < bigScore.type3[1]">
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                  <div class="preData">{{ bigScore.type3[1] }}</div>
                  <div class="type">培训</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">评估者占比 <span class="badge">TTL {{ evaluationTotal }}</span></div>
              <div class="evaluation">
                <div class="leftPart">

                </div>
                <div id="c2" class="c2">

                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">行动完成情况 <span class="badge">TTL {{ activityTotal }}</span></div>
              <div class="evaluation">
                <div class="leftPart">

                </div>
                <div id="c3" class="c3">

                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-card class="box-card" style="margin-top: 20px">
          <div class="title">检查项目得分分析</div>
          <div id="c4" class="c4">

          </div>
        </el-card>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">区域评估完成率 <span class="tag">店铺数量 <i class="el-icon-s-shop"></i></span></div>
              <div class="assessment">
                <div class="leftChart" ref="chartLeft1">
                  <div id="c5" class="c5">

                  </div>
                </div>
                <div class="rightChart">
                  <div class="firstLine" v-if="dateSwitch">
                    <span>本月完成率</span>
                    <span>上月完成率</span>
                  </div>
                  <div class="firstLine" v-else>
                    <span>本季度完成率</span>
                    <span>上季度完成率</span>
                  </div>
                  <div class="areaData" v-for="(item, index) in areaData" :key="index">
                    <div class="curMonth">
                      <span>{{ item.curData }}%</span>
                      <div class="icon upIcon" v-if="item.curData > item.preData">
                        <i class="el-icon-top"></i>
                      </div>
                      <div class="icon downIcon" v-if="item.curData < item.preData">
                        <i class="el-icon-bottom"></i>
                      </div>
                    </div>
                    <div class="preMonth">{{ item.preData }}%</div>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">区域得分分布<span class="tag">店铺数量 <i class="el-icon-s-shop"></i></span></div>
              <div class="customerScore">
                <div class="leftChart" ref="chartLeft2">
                  <div id="c6" class="c6"></div>
                </div>
                <div class="rightChart">
                  <ul>
                    <li v-for="(item, index) in avgScores1" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">客户评估完成率 <span class="tag">店铺数量 <i class="el-icon-s-shop"></i></span></div>
              <div class="assessment">
                <div class="leftChart">
                  <div id="c7" class="c7">

                  </div>
                </div>
                <div class="rightChart">
                  <div class="firstLine" v-if="dateSwitch">
                    <span>本月完成率</span>
                    <span>上月完成率</span>
                  </div>
                  <div class="firstLine" v-else>
                    <span>本季度完成率</span>
                    <span>上季度完成率</span>
                  </div>
                  <div class="areaData" v-for="(item, index) in customerData" :key="index">
                    <div class="curMonth">
                      <span>{{ item.curData }}%</span>
                      <div class="icon upIcon" v-if="item.curData > item.preData">
                        <i class="el-icon-top"></i>
                      </div>
                      <div class="icon downIcon" v-if="item.curData < item.preData">
                        <i class="el-icon-bottom"></i>
                      </div>
                    </div>
                    <div class="preMonth">{{ item.preData }}%</div>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">客户得分分布 <span class="tag">店铺数量 <i class="el-icon-s-shop"></i></span></div>
              <div class="customerScore">
                <div class="leftChart">
                  <div id="c8" class="c8"></div>
                </div>
                <div class="rightChart">
                  <ul>
                    <li v-for="(item, index) in avgScores2" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-card class="box-card tableBox" style="margin-top: 20px">
          <div class="title">优势和机会点</div>
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="9">
              <template>
                <el-table
                  :data="tableData1"
                  style="width: 100%"
                  :header-cell-style="tableHeadStyle"
                >
                  <el-table-column
                    prop="advantage"
                    label="优势"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="curMonth"
                    :label="this.dateSwitch ? '本月' : '本季度'"
                    width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.curMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="preMonth"
                    :label="this.dateSwitch ? '上月' : '上季度'"
                    width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.preMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="↑/↓"
                    width="40">
                    <template slot-scope="scope">
                    <span v-if="scope.row.preMonth < scope.row.curMonth">
                      <i class="el-icon-top up"></i>
                    </span>
                      <span v-if="scope.row.preMonth > scope.row.curMonth">
                      <i class="el-icon-bottom down"></i>
                    </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-col>
            <el-col :span="15">
              <template>
                <el-table
                  :data="tableData2"
                  style="width: 100%"
                  :header-cell-style="tableHeadStyle"
                >
                  <el-table-column
                    prop="advantage"
                    label="机会点"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="problem"
                    label="问题">
                  </el-table-column>
                  <el-table-column
                    prop="curMonth"
                    :label="this.dateSwitch ? '本月' : '本季度'"
                    width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.curMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="preMonth"
                    :label="this.dateSwitch ? '上月' : '上季度'"
                    width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.preMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="↑/↓"
                    width="40">
                    <template slot-scope="scope">
                    <span v-if="scope.row.preMonth < scope.row.curMonth">
                      <i class="el-icon-top up"></i>
                    </span>
                      <span v-if="scope.row.preMonth > scope.row.curMonth">
                      <i class="el-icon-bottom down"></i>
                    </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import {Chart} from '@antv/g2';
import _ from 'lodash'

export default {
  name: "homeTotal",
  mounted() {
    // 获取数据
    // this.getData();
    this.getQuarter()
    this.getDataRangeOptions()
  },
  data() {
    return {
      avgScores1: [],
      avgScores2: [],
      dateSwitch: true,
      dateSelect: null,
      initDate: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      chart7: null,
      chart8: null,
      filterData: {},
      initialFilterData: {
        region: null,
        city: null,
        door: null,
      },
      areaList: [],
      cityList: [],
      doorList: [],
      activeName: "first",
      reportName: "全国报告",
      resData: {},
      curScore: 0,
      preScore: 0,
      bigScore: {
        type1: [0, 0],
        type2: [0, 0],
        type3: [0, 0]
      }, // 大项得分分析数据,数据结构前后端修改都可以
      evaluationTotal: 0,
      activityTotal: 0,
      rankData: {
        type1: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
        type2: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
        type3: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
        type4: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
      },// 排名情况数据,
      tableData1: [],
      tableData2: [
        {
          advantage: "",
          problem: "",
          curMonth: 0,
          preMonth: 0
        }
      ],
      tableHeadStyle: {
        background: "#67C23A",
        color: "#fff"
      },
      areaData: [],
      customerData: [],
      customerDistributeData: [],
      scoredistributeData: [],
      searchData: {  //搜索条件
        city: null,
        door: null,
        mold: 1,  //1季度  2月
        region: null,
        type: 1,  // 1全国 2大区 3城市 4单店
        value: 0,
        year: 2021,
        scopes: [],
      },
      initScopes: ['all'],
      dashboardFlag: 1,
      dataRangeOptions: [
      ]
    }
  },
  methods: {
    selectSingle() {
      _.remove(this.searchData.scopes, item => item === 'all');
      this.searchData.scopes = _.cloneDeep(this.searchData.scopes)
    },
    selectAll() {
      this.searchData.scopes = ['all']
    },
    async getDataRangeOptions() {
      let res = await axios.post(oprReqUrl+"/account/dataRoleList");
      if (res.data.code === 200) {
        this.dataRangeOptions = res.data.data
        this.searchData.scopes = this.initScopes
      }
    },
    resetSearch() {
      this.dateSelect = this.initDate
      this.searchData.scopes = this.initScopes
    },
    getQuarter() {
      let date = new Date();
      let year = date.getFullYear();
      this.searchData.year = year
      let month = date.getMonth();
      if (this.dateSwitch) {
        this.dateSelect = new Date(year, month)
        this.initDate = new Date(year, month)
        return
      }
      if (month < 3) {
        this.dateSelect = 1
        this.initDate = 1
      } else if (month < 6) {
        this.dateSelect = 2
        this.initDate = 2
      } else if (month < 9) {
        this.dateSelect = 3
        this.initDate = 3
      } else if (month < 12) {
        this.dateSelect = 4
        this.initDate = 3
      }
    },
    async getData() {
      this.searchData.mold = this.dateSwitch ? 2 : 1
      _.remove(this.searchData.scopes, item => item === 'all');
      if (this.searchData.mold == 2) {
        this.searchData.value = this.dateSelect.getMonth() + 1
        this.searchData.year = this.dateSelect.getFullYear()
      } else {
        this.searchData.value = this.dateSelect
      }
      
      
      let res = await axios.post(oprReqUrl+"/api/report", this.searchData);
      res = res.data
      if (res.code === 200) {
        this.resData = res.data
        /* if (this.dateSwitch) {
          // todo 临时数据
          let resTemp = JSON.parse('{"code":200,"message":"SUCCESS","data":{"reportName":"全国报告2021.8","score":{"description":"得分情况","now":0.7445736842,"previous":0.7986100000},"role":{"description":"评估者占比","list":[{"name":"Admin","value":2},{"name":"HC","value":6},{"name":"HM","value":1},{"name":"RO","value":1},{"name":"TTT","value":1},{"name":"VMS","value":1},{"name":"总部NSAE","value":1},{"name":"总部VMS","value":6}],"TTL":19},"trend":{"description":"得分趋势图","data":[{"name":"2021.8","value":0.7445736842},{"name":"2021.7","value":0.7986100000},{"name":"2021.6","value":0.7464400000}]},"action":{"description":"行动完成情况","nofinish":3,"finishpass":3,"finishnopass":0,"timeout":1,"total":6},"finishrate":{"description":"区域评估完成率","data":[{"total":3,"previousfinish":2,"regionName":"大北京","finish":3,"regionNO":"31A3FFC424BJ"},{"total":2,"previousfinish":0,"regionName":"大湾区","finish":2,"regionNO":"D0121EB7DBA7"},{"total":2,"previousfinish":0,"regionName":"成渝","finish":2,"regionNO":"FB8F759047A3"},{"total":2,"previousfinish":0,"regionName":"大上海","finish":2,"regionNO":"FB8F759047SH"}]},"scoredistribute":{"description":"区域得分分布","data":[{"name":"成渝","lt60":0,"gt90":2,"gt80":0,"gt60":0,"avg":0.9594500000},{"name":"大北京","lt60":1,"gt90":1,"gt80":0,"gt60":1,"avg":0.6570909091},{"name":"大上海","lt60":1,"gt90":1,"gt80":0,"gt60":0,"avg":0.6438500000},{"name":"大湾区","lt60":0,"gt90":1,"gt80":1,"gt60":0,"avg":0.9280750000}]},"customerfinish":{"description":"客户评估完成率","data":[{"total":1,"resellerName":"Others","previousfinish":0,"finish":1,"resellerNO":"DF5F2013B157"},{"total":8,"resellerName":"TOPSPORTS","previousfinish":2,"finish":8,"resellerNO":"F2EC073385F6"}]},"customerscore":{"description":"客户得分分布","data":[{"lt60":0,"avg":1.0000000000,"gt90":1,"gt80":0,"gt60":0,"name":"Others"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"TOPSPORTS"}]},"analyse":{"description":"大项得分分析","nowVMS":0.7169315789,"preVMS":0.8270300000,"nowOPERATION":0.5274526316,"preOPERATION":0.7666600000,"nowTRAINING":0.5157894737,"preTRAINING":0.7733400000},"checkitem":{"description":"检查项目得分分析","data":[{"a":73,"b":23,"c":96,"d":0.7604,"name":"货品陈列"},{"a":47,"b":9,"c":56,"d":0.8393,"name":"模特、板墙及道具陈列"},{"a":26,"b":6,"c":32,"d":0.8125,"name":"后期检查维护"},{"a":45,"b":11,"c":56,"d":0.8036,"name":"市场活动"},{"a":0,"b":0,"c":0,"name":"BE A COACH精英教练"},{"a":11,"b":5,"c":16,"d":0.6875,"name":"反馈"},{"a":0,"b":0,"c":0,"name":"SFL2.0领导力2.0"},{"a":33,"b":7,"c":40,"d":0.8250,"name":"后场管理"},{"a":0,"b":0,"c":0,"name":"SYPB全力以服"},{"a":38,"b":7,"c":45,"d":0.8444,"name":"前场整洁"},{"a":0,"b":0,"c":0,"name":"ATHLETE 15培训日历"},{"a":35,"b":5,"c":40,"d":0.8750,"name":"后仓有序"},{"a":1,"b":0,"c":1,"d":1.0000,"name":"耐克学道GET IT"},{"a":10,"b":2,"c":12,"d":0.8333,"name":"LISTEN U零听"},{"a":0,"b":0,"c":0,"name":"DNA课程"},{"a":2,"b":0,"c":2,"d":1.0000,"name":"STO Download开季培训"},{"a":18,"b":2,"c":20,"d":0.9000,"name":"NIKE工服"},{"a":3,"b":0,"c":3,"d":1.0000,"name":"Selling Skills销售技巧"}]},"superiority":{"description":"优势与机会点","advantage":[{"a":3,"b":0,"c":3,"d":1.0000,"e":0.8889,"name":"Selling Skills销售技巧"},{"a":1,"b":0,"c":1,"d":1.0000,"e":0.7333,"name":"耐克学道GET IT"},{"a":2,"b":0,"c":2,"d":1.0000,"e":0.8333,"name":"STO Download开季培训"},{"a":18,"b":2,"c":20,"d":0.9000,"e":0.7833,"name":"NIKE工服"},{"a":35,"b":5,"c":40,"d":0.8750,"e":0.8083,"name":"后仓有序"}],"chance":[{"checkitem":"DNA课程","a":0,"b":0,"c":0,"question":"运动员是否都有自己的DNA场地记录？","d":0,"e":0.8667},{"checkitem":"SYPB全力以服","a":0,"b":0,"c":0,"question":"店铺是否参加SYPB项目？","d":0,"e":0.6667},{"checkitem":"ATHLETE 15培训日历","a":0,"b":0,"c":0,"question":"运动员是否了解当天的 ATHLETE 15 培训主题？","d":0,"e":0.8000},{"checkitem":"BE A COACH精英教练","a":0,"b":0,"c":0,"question":"后仓或休息室内，是否有店铺的愿景和价值观？","d":0,"e":0.4667},{"checkitem":"SYPB全力以服","a":0,"b":0,"c":0,"question":"店铺是否有在后仓或员工休息室装置 SYPB 海报？","d":0,"e":0.6667}]}}}')
          this.resData = resTemp.data
        } else {
          // todo 临时数据
          let resTemp = JSON.parse('{"code":200,"message":"SUCCESS","data":{"reportName":"全国报告2021.8","score":{"description":"得分情况","now":0.7445736842,"previous":0.7986100000},"role":{"description":"评估者占比","list":[{"name":"Admin","value":2},{"name":"HC","value":6},{"name":"HM","value":1},{"name":"RO","value":1},{"name":"TTT","value":1},{"name":"VMS","value":1},{"name":"总部NSAE","value":1},{"name":"总部VMS","value":6}],"TTL":19},"trend":{"description":"得分趋势图","data":[{"name":"2021.8","value":0.7445736842},{"name":"2021.7","value":0.7986100000},{"name":"2021.6","value":0.7464400000}]},"action":{"description":"行动完成情况","nofinish":3,"finishpass":3,"finishnopass":0,"timeout":1,"total":6},"finishrate":{"description":"区域评估完成率","data":[{"total":3,"previousfinish":2,"regionName":"大北京","finish":3,"regionNO":"31A3FFC424BJ"},{"total":2,"previousfinish":0,"regionName":"大湾区","finish":2,"regionNO":"D0121EB7DBA7"},{"total":2,"previousfinish":0,"regionName":"成渝","finish":2,"regionNO":"FB8F759047A3"},{"total":2,"previousfinish":0,"regionName":"大上海","finish":2,"regionNO":"FB8F759047SH"}]},"scoredistribute":{"description":"区域得分分布","data":[{"name":"成渝","lt60":0,"gt90":2,"gt80":0,"gt60":0,"avg":0.9594500000},{"name":"大北京","lt60":1,"gt90":1,"gt80":0,"gt60":1,"avg":0.6570909091},{"name":"大上海","lt60":1,"gt90":1,"gt80":0,"gt60":0,"avg":0.6438500000},{"name":"大湾区","lt60":0,"gt90":1,"gt80":1,"gt60":0,"avg":0.9280750000}]},"customerfinish":{"description":"客户评估完成率","data":[{"total":1,"resellerName":"Others","previousfinish":0,"finish":1,"resellerNO":"DF5F2013B157"},{"total":8,"resellerName":"TOPSPORTS","previousfinish":2,"finish":8,"resellerNO":"F2EC073385F6"}]},"customerscore":{"description":"客户得分分布","data":[{"lt60":0,"avg":1.0000000000,"gt90":1,"gt80":0,"gt60":0,"name":"Others"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"TOPSPORTS"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"test"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"ttt"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"aaaa"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"bbbb"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"ccccc"}]},"analyse":{"description":"大项得分分析","nowVMS":0.7169315789,"preVMS":0.8270300000,"nowOPERATION":0.5274526316,"preOPERATION":0.7666600000,"nowTRAINING":0.5157894737,"preTRAINING":0.7733400000},"checkitem":{"description":"检查项目得分分析","data":[{"a":73,"b":23,"c":96,"d":0.7604,"name":"货品陈列"},{"a":47,"b":9,"c":56,"d":0.8393,"name":"模特、板墙及道具陈列"},{"a":26,"b":6,"c":32,"d":0.8125,"name":"后期检查维护"},{"a":45,"b":11,"c":56,"d":0.8036,"name":"市场活动"},{"a":0,"b":0,"c":0,"name":"BE A COACH精英教练"},{"a":11,"b":5,"c":16,"d":0.6875,"name":"反馈"},{"a":0,"b":0,"c":0,"name":"SFL2.0领导力2.0"},{"a":33,"b":7,"c":40,"d":0.8250,"name":"后场管理"},{"a":0,"b":0,"c":0,"name":"SYPB全力以服"},{"a":38,"b":7,"c":45,"d":0.8444,"name":"前场整洁"},{"a":0,"b":0,"c":0,"name":"ATHLETE 15培训日历"},{"a":35,"b":5,"c":40,"d":0.8750,"name":"后仓有序"},{"a":1,"b":0,"c":1,"d":1.0000,"name":"耐克学道GET IT"},{"a":10,"b":2,"c":12,"d":0.8333,"name":"LISTEN U零听"},{"a":0,"b":0,"c":0,"name":"DNA课程"},{"a":2,"b":0,"c":2,"d":1.0000,"name":"STO Download开季培训"},{"a":18,"b":2,"c":20,"d":0.9000,"name":"NIKE工服"},{"a":3,"b":0,"c":3,"d":1.0000,"name":"Selling Skills销售技巧"}]},"superiority":{"description":"优势与机会点","advantage":[{"a":3,"b":0,"c":3,"d":1.0000,"e":0.8889,"name":"Selling Skills销售技巧"},{"a":1,"b":0,"c":1,"d":1.0000,"e":0.7333,"name":"耐克学道GET IT"},{"a":2,"b":0,"c":2,"d":1.0000,"e":0.8333,"name":"STO Download开季培训"},{"a":18,"b":2,"c":20,"d":0.9000,"e":0.7833,"name":"NIKE工服"},{"a":35,"b":5,"c":40,"d":0.8750,"e":0.8083,"name":"后仓有序"}],"chance":[{"checkitem":"DNA课程","a":0,"b":0,"c":0,"question":"运动员是否都有自己的DNA场地记录？","d":0,"e":0.8667},{"checkitem":"SYPB全力以服","a":0,"b":0,"c":0,"question":"店铺是否参加SYPB项目？","d":0,"e":0.6667},{"checkitem":"ATHLETE 15培训日历","a":0,"b":0,"c":0,"question":"运动员是否了解当天的 ATHLETE 15 培训主题？","d":0,"e":0.8000},{"checkitem":"BE A COACH精英教练","a":0,"b":0,"c":0,"question":"后仓或休息室内，是否有店铺的愿景和价值观？","d":0,"e":0.4667},{"checkitem":"SYPB全力以服","a":0,"b":0,"c":0,"question":"店铺是否有在后仓或员工休息室装置 SYPB 海报？","d":0,"e":0.6667}]}}}')
          this.resData = resTemp.data
        } */

        this.reportName = res.data.reportName

        // 得分情况
        this.scoreData();

        // 得分趋势图
        this.renderC1();

        //大项得分分析
        this.bigScoreData();

        // 评估者占比
        this.renderC2();

        // 行动完成情况
        this.renderC3();

        // 检查项目得分分析
        this.renderC4();

        // 区域评估完成率
        this.renderC5();

        // 区域得分分布
        this.renderC6();

        // 客户评估完成率
        this.renderC7();

        // 客户得分分布
        this.renderC8();

        // 优势和机会点
        this.superiority();
      }
    },
    // 得分情况
    scoreData() {
      let res = this.resData.score;
      this.curScore = this.numberPercentageFormat(res.now);
      this.preScore = this.numberPercentageFormat(res.previous);
    },
    // 大项得分分析
    bigScoreData() {
      //大项得分分析
      let res = this.resData.analyse;

      let nowVMS = this.numberPercentageFormat(res.nowVMS);
      let nowOPERATION = this.numberPercentageFormat(res.nowOPERATION);
      let nowTRAINING = this.numberPercentageFormat(res.nowTRAINING);

      let preVMS = this.numberPercentageFormat(res.preVMS);
      let preOPERATION = this.numberPercentageFormat(res.preOPERATION);
      let preTRAINING = this.numberPercentageFormat(res.preTRAINING);

      let type1 = [nowVMS, preVMS]
      let type2 = [nowOPERATION, preOPERATION]
      let type3 = [nowTRAINING, preTRAINING]
      let bigScoreData = {type1: type1, type2: type2, type3: type3}
      this.bigScore = bigScoreData
    },
    // 渲染id为C1的图表
    renderC1() {
      let res = this.resData.trend.data;
      let trendData = []
      res.forEach((item) => {
        let row = {date: item.name, value: this.numberPercentageFormat(item.value)}
        trendData.unshift(row)
      })
      const data = trendData;

      if (this.chart1 != null) {
        this.chart1.data(data)
        this.chart1.render()
        return
      }
      const chart = new Chart({
        container: 'c1',
        autoFit: true,
        height: 200,
      });

      chart.data(data);
      chart.scale({
        date: {
          range: [0, 1],
        },
        value: {
          min: 0,
          max: 110,
          nice: true,
        },
      });

      chart.tooltip({
        showCrosshairs: false, // 是否展示 Tooltip 辅助线
        shared: true,
      });

      const geometry1 = chart.line().position('date*value').label('value');
      const geometry2 = chart.point().position('date*value');
      geometry1.color('#67C23A');
      geometry2.color('#67C23A');
      geometry1.label(
        'value',
        (val) => {
          return {
            content: val,
          };
        },
        {
          type: 'base', // 声明 label 类型
        }
      );

      chart.axis('value', false);
      // chart.render();
      this.chart1 = chart
      this.chart1.render()
    },
    // 评估者占比
    renderC2() {
      let total = this.resData.role.TTL * 1;
      this.evaluationTotal = total
      let roleData = this.resData.role.list;
      let roleDataTemp = [];
      roleData.forEach((item) => {
        let itemPercent = this.numberPercentageFormat(item.value / total)
        let row = {item: item.name, count: item.value, percent: itemPercent}
        roleDataTemp.push(row)
      })
      const data = roleDataTemp

      if (this.chart2 != null) {
        this.chart2.data(data)
        this.chart2.render()
        return
      }

      const chart = new Chart({
        container: 'c2',
        autoFit: true,
        height: 200,
      });

      chart.coordinate('theta', {
        radius: 0.75,
      });

      chart.data(data);

      chart.scale('percent', {
        formatter: (val) => {
          val = val + '%';
          return val;
        },
      });

      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });

      const geometry = chart
        .interval()
        .position('percent')
        .color('item')
        .label('percent', {
          content: (data) => {
            return `${data.item}: ${data.percent}%`;
          },
        })
        .adjust('stack');

      geometry.label(false);
      geometry.color('item', ['#24e059', '#a7f3bd', '#66e98b', '#b3b3b3', '#333333', '#7f7f7f', '#2A6FA5', '#37DFDF']);

      chart.interaction('element-active');

      // chart.render();
      this.chart2 = chart
      this.chart2.render()
    },
    // 行动完成情况
    renderC3() {
      let actionData = this.resData.action;
      let total = actionData.total;
      let noFinish = actionData.nofinish;
      let noPass = actionData.finishnopass;
      let pass = actionData.finishpass;
      let timeout = actionData.timeout;
      this.activityTotal = total;
      const data = [
        {item: '未完成 ' + noFinish, count: noFinish, percent: this.numberPercentageFormat(noFinish / total)},
        {item: '已完成已通过 ' + pass, count: pass, percent: this.numberPercentageFormat(pass / total)},
        {item: '已完成未通过 ' + noPass, count: noPass, percent: this.numberPercentageFormat(noPass / total)},
        {item: '已超时 ' + timeout, count: timeout, percent: this.numberPercentageFormat(timeout / total)},
      ];

      if (this.chart3 != null) {
        this.chart3.data(data)
        this.chart3.render()
        return
      }

      const chart = new Chart({
        container: 'c3',
        autoFit: true,
        height: 200,
      });

      chart.coordinate('theta', {
        radius: 0.75,
      });

      chart.data(data);

      chart.scale('percent', {
        formatter: (val) => {
          val = val + '%';
          return val;
        },
      });

      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });

      const geometry = chart
        .interval()
        .position('percent')
        .color('item')
        .label('percent', {
          content: (data) => {
            return `${data.item}: ${data.percent}%`;
          },
        })
        .adjust('stack');

      geometry.label(false);
      geometry.color('item', ['#91efac', '#24e059', '#b3b3b3', '#333333']);

      chart.interaction('element-active');

      this.chart3 = chart
      this.chart3.render()
    },
    renderC4() {
      let res = this.resData.checkitem.data;
      let checkItemData = []
      res.forEach(item => {

        let rate = this.numberPercentageFormat(item.d)
        let row = {type: item.name, value: rate}
        checkItemData.push(row)
      })
      const data = checkItemData

      if (this.chart4 != null) {
        this.chart4.data(data)
        this.chart4.render()
        return
      }

      // Step 1: 创建 Chart 对象

      // Step 2: 载入数据源

      // Step 3: 创建图形语法，绘制折线图

      // Step 4: 渲染图表

      const chart = new Chart({
        container: 'c4',
        autoFit: true,
        // width: 2500,
        height: 300,
      });

      chart.data(data);
      chart.scale({
        value: {
          min: 0,
          max: 110,
          nice: true,
        },
      });

      chart.tooltip({
        showCrosshairs: false, // 是否展示 Tooltip 辅助线
        shared: true,
      });

      const geometry1 = chart.line().position('type*value').label('value');
      const geometry2 = chart.point().position('type*value');
      geometry1.color('#67C23A');
      geometry2.color('#67C23A');
      geometry1.label(
        'value',
        (val) => {
          return {
            content: val,
          };
        },
        {
          type: 'base', // 声明 label 类型
        }
      );

      chart.axis('value', false);
      chart.axis('type', {
        label: {
          offset: 70,
          rotate: 190.07,
          // autoRotate: true
        }
      });
      this.chart4 = chart
      this.chart4.render()
    },
    renderC5() {
      let res = this.resData.finishrate.data;
      let len = res.length || 0
      let chartHeight = (40 * len + 54) * 1
      let areaData = []
      let areaRateData = []
      res.forEach(item => {
        let notFinish = item.total - item.finish;
        let rate = item.finish / item.total;
        let rateFmt = this.numberFormat(rate);
        let notRate = 1 - rateFmt;
        let preRate = item.previousfinish / item.total;
        let row = {city: item.regionName, type: '完成的店铺数', value: rateFmt, eValue: item.finish}
        let row2 = {city: item.regionName, type: '未完成的店铺数', value: notRate, eValue: notFinish}
        areaData.unshift(row)
        areaData.unshift(row2)
        let rateData = {area: item.regionName, curData: this.numberPercentageFormat(rate), preData: this.numberPercentageFormat(preRate)}
        areaRateData.push(rateData)
      })

      const data = areaData

      this.areaData = areaRateData

      if (this.chart5 != null) {
        this.chart5.data(data)
        this.chart5.render()
        const parentClientWidth = this.$refs.chartLeft1.clientWidth;
        this.chart5.changeSize(parentClientWidth, chartHeight)
        return
      }

      const chart = new Chart({
        container: 'c5',
        autoFit: true,
        height: chartHeight, // todo: 这个高度要根据数据的条数进行动态计算的, 40*区域数量 + 54
      });
      chart.data(data);
      chart.scale('value', {
        alias: ' ',
      });
      chart.axis('city', {
        tickLine: null,
        line: null,
        label: {
          formatter: (text, item, index) => {
            // todo: 可能要加上总数,但目前还不太清楚怎么实现,icon肯定加不进去
            /*              console.log('text', text);
                          console.log('item', item);
                          console.log('index', index);*/
            return text
          }
        }
      });
      chart.axis('value', {
        label: null,
        title: {
          style: {
            fontSize: 14,
            fontWeight: 300,
          },
        },
        grid: null,
      });
      chart.legend({
        position: 'top',
      });
      chart.coordinate('rect').transpose();
      chart.tooltip({
        shared: true,
        showMarkers: false,
        customItems: (items) => {
          _.each(items, (item) => item.value = item.data.eValue);
          return (items);
        },
      });
      chart.interaction('active-region');
      chart
        .interval()
        .adjust('stack')
        .position('city*value')
        .color('type*city', (type, city) => {
          if (type === '完成的店铺数') {
            return '#24e059';
          }
          if (type === '未完成的店铺数') {
            return '#e0e0e0';
          }
        })
        .size(26)
        .label('value*type', (val, t) => {
          const color = t === '未完成的店铺数' ? 'white' : '#47494b';
          if (val < 0.05) {
            return null;
          }
          return {
            position: 'middle',
            offset: 0,
            style: {
              fontSize: 12,
              fill: color,
              lineWidth: 0,
              stroke: null,
              shadowBlur: 2,
              shadowColor: 'rgba(0, 0, 0, .45)',
            },
          };
        })
        .label('eValue*type', (val, t) => {
          const color = t === '未完成的店铺数' ? 'white' : '#47494b';
          return {
            position: 'middle',
            offset: 0,
            style: {
              fill: color,
            },
            content: val
          };
        });

      this.chart5 = chart
      this.chart5.render()
    },
    renderC6() {
      let res = this.resData.scoredistribute.data;
      let len = res.length || 1
      let chartHeight = (40 * len + 54) * 1;
      let scoredistributeData = [];
      let avgScores = []
      res.forEach(item => {
        let number1 = item.gt90   // >=90
        let number2 = item.gt80   // 80-90
        let number3 = item.gt60   // 60-80
        let number4 = item.lt60   // <60
        let avg = this.numberPercentageFormat(item.avg)
        let total = number1 + number2 + number3 + number4;
        let rate1 = this.numberPercentageFormat(number1 / total);
        let rate2 = this.numberPercentageFormat(number2 / total);
        let rate3 = this.numberPercentageFormat(number3 / total);
        let rate4 = this.numberFormat(100 - rate1 - rate2 - rate3);
        let row1 = {city: item.name, type: '>=90', value: rate1}
        let row2 = {city: item.name, type: '80-90', value: rate2}
        let row3 = {city: item.name, type: '60-80', value: rate3}
        let row4 = {city: item.name, type: '<60', value: rate4}

        scoredistributeData.unshift(row1, row2, row3, row4)
        avgScores.push(avg)
      })
      this.avgScores1 = avgScores;
      const data = scoredistributeData

      if (this.chart6 != null && data.length !== 0) {
        this.chart6.data(data)
        this.chart6.render()
        const parentClientWidth = this.$refs.chartLeft2.clientWidth;
        this.chart6.changeSize(parentClientWidth, chartHeight)
        return
      }

      if (this.chart6 != null && data.length === 0) {
        this.chart6.destroy();
        this.chart6 = null
      }

      const chart = new Chart({
        container: 'c6',
        autoFit: true,
        height: chartHeight, // todo: 这个高度要根据数据的条数进行动态计算的, 40*区域数量 + 54
      });
      chart.data(data);
      chart.scale('value', {
        alias: ' ',
      });
      chart.axis('city', {
        tickLine: null,
        line: null,
        label: {
          formatter: (text, item, index) => {
            // todo: 可能要加上总数,但目前还不太清楚怎么实现,icon肯定加不进去
            /*              console.log('text', text);
                          console.log('item', item);
                          console.log('index', index);*/
            return text
          }
        }
      });
      chart.axis('value', {
        label: null,
        title: {
          style: {
            fontSize: 14,
            fontWeight: 300,
          },
        },
        grid: null,
      });
      chart.legend({
        position: 'top',
      });
      chart.coordinate('rect').transpose();
      chart.tooltip({
        shared: true,
        showMarkers: false,
        customItems: (items) => {
          _.each(items, (item) => item.value = item.value + '%');
          return (items);
        },
      });
      chart.interaction('active-region');
      chart
        .interval()
        .adjust('stack')
        .position('city*value')
        .color('type*city', (type, city) => {
          if (type === '>=90') {
            return '#24e059';
          }
          if (type === '80-90') {
            return '#66e98b';
          }
          if (type === '60-80') {
            return '#a7f3bd';
          }
          if (type === '<60') {
            return '#e0e0e0';
          }
        })
        .size(26)
        .label('value*type', (val, t) => {
          const color = (t === '80-90' || t === '>=90') ? 'white' : '#47494b';
          if (val < 0.05) {
            return null;
          }
          return {
            position: 'middle',
            offset: 0,
            style: {
              fontSize: 12,
              fill: color,
              lineWidth: 0,
              stroke: null,
            },
            content: val
          };
        })

      this.chart6 = chart
      this.chart6.render()
    },
    renderC7() {
      let res = this.resData.customerfinish.data;
      let len = res.length || 0
      let chartHeight = (40 * len + 54) * 1;
      let resData = []
      let rateData = [] //完成率
      res.forEach(item => {
        let total = item.total;
        //完成店铺
        let finish = item.finish;
        //未完成店铺
        let noFinish = total - finish;
        // 上月完成店铺
        let preFinish = item.previousfinish;
        // 上月未完成店铺
        let preNoFinish = total - preFinish;

        //本月完成率
        let rate = finish / total;
        let rateFmt = this.numberFormat(rate);
        let rateNotFinish = 1 - rateFmt;
        //上月完成率
        let preRate = preFinish / total;
        let row = {city: item.resellerName, type: '完成的店铺数', value: rateFmt, eValue: finish}
        let row2 = {city: item.resellerName, type: '未完成的店铺数', value: rateNotFinish, eValue: noFinish}
        resData.unshift(row)
        resData.unshift(row2)
        let rateRow = {area: item.resellerName, curData: this.numberPercentageFormat(rate), preData: this.numberPercentageFormat(preRate)}
        rateData.push(rateRow)
      })
      this.customerData = rateData
      const data = resData;

      if (this.chart7 != null) {
        this.chart7.data(data)
        this.chart7.render()
        const parentClientWidth = this.$refs.chartLeft1.clientWidth;
        this.chart7.changeSize(parentClientWidth, chartHeight)
        return
      }

      const chart = new Chart({
        container: 'c7',
        autoFit: true,
        height: chartHeight, // todo: 这个高度要根据数据的条数进行动态计算的, 40*区域数量 + 54
      });
      chart.data(data);
      chart.scale('value', {
        alias: ' ',
      });
      chart.axis('city', {
        tickLine: null,
        line: null,
        label: {
          formatter: (text, item, index) => {
            // todo: 可能要加上总数,但目前还不太清楚怎么实现,icon肯定加不进去
            /*              console.log('text', text);
                          console.log('item', item);
                          console.log('index', index);*/
            return text
          }
        }
      });
      chart.axis('value', {
        label: null,
        title: {
          style: {
            fontSize: 14,
            fontWeight: 300,
          },
        },
        grid: null,
      });
      chart.legend({
        position: 'top',
      });
      chart.coordinate('rect').transpose();
      chart.tooltip({
        shared: true,
        showMarkers: false,
        customItems: (items) => {
          _.each(items, (item) => item.value = item.data.eValue);
          return (items);
        },
      });
      chart.interaction('active-region');
      chart
        .interval()
        .adjust('stack')
        .position('city*value')
        .color('type*city', (type, city) => {
          if (type === '完成的店铺数') {
            return '#24e059';
          }
          if (type === '未完成的店铺数') {
            return '#e0e0e0';
          }
        })
        .size(26)
        .label('value*type', (val, t) => {
          const color = t === '未完成的店铺数' ? 'white' : '#47494b';
          if (val < 0.05) {
            return null;
          }
          return {
            position: 'middle',
            offset: 0,
            style: {
              fontSize: 12,
              fill: color,
              lineWidth: 0,
              stroke: null,
              shadowBlur: 2,
              shadowColor: 'rgba(0, 0, 0, .45)',
            },
          };
        })
        .label('eValue*type', (val, t) => {
          const color = t === '未完成的店铺数' ? 'white' : '#47494b';
          return {
            position: 'middle',
            offset: 0,
            style: {
              fill: color,
            },
            content: val
          };
        });

      this.chart7 = chart
      this.chart7.render()
    },
    numberFormat(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      let res = (data * 1).toFixed(1) * 1
      return res
    },
    numberPercentageFormat(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      let res = (data * 1 * 100).toFixed(1) * 1
      return res
    },
    renderC8() {
      let res = this.resData.customerscore.data;
      let len = res.length || 1
      let chartHeight = (40 * len + 54) * 1;
      let customerScoreData = []
      let avgScores = []
      res.forEach(item => {

        let number1 = item.gt90   // >=90
        let number2 = item.gt80   // 80-90
        let number3 = item.gt60   // 60-80
        let number4 = item.lt60   // <60
        let avg = this.numberPercentageFormat(item.avg)
        let total = number1 + number2 + number3 + number4;
        let rate1 = this.numberPercentageFormat(number1 / total);
        let rate2 = this.numberPercentageFormat(number2 / total);
        let rate3 = this.numberPercentageFormat(number3 / total);
        let rate4 = this.numberFormat(100 - rate1 - rate2 - rate3);
        let row1 = {city: item.name, type: '>=90', value: rate1}
        let row2 = {city: item.name, type: '80-90', value: rate2}
        let row3 = {city: item.name, type: '60-80', value: rate3}
        let row4 = {city: item.name, type: '<60', value: rate4}
        customerScoreData.push(row1, row2, row3, row4)
        avgScores.unshift(avg)
      })
      this.avgScores2 = avgScores
      const data = customerScoreData

      if (this.chart8 != null && data.length !== 0) {
        this.chart8.data(data)
        this.chart8.render()
        const parentClientWidth = this.$refs.chartLeft2.clientWidth;
        this.chart8.changeSize(parentClientWidth, chartHeight)
        return
      }

      if (this.chart8 != null && data.length === 0) {
        this.chart8.destroy();
        this.chart8 = null
      }

      const chart = new Chart({
        container: 'c8',
        autoFit: true,
        height: chartHeight, // todo: 这个高度要根据数据的条数进行动态计算的, 40*区域数量 + 54
      });
      chart.data(data);
      chart.scale('value', {
        alias: ' ',
      });
      chart.axis('city', {
        tickLine: null,
        line: null,
        label: {
          formatter: (text, item, index) => {
            // todo: 可能要加上总数,但目前还不太清楚怎么实现,icon肯定加不进去
            /*              console.log('text', text);
                          console.log('item', item);
                          console.log('index', index);*/
            return text
          }
        }
      });
      chart.axis('value', {
        label: null,
        title: {
          style: {
            fontSize: 14,
            fontWeight: 300,
          },
        },
        grid: null,
      });
      chart.legend({
        position: 'top',
      });
      chart.coordinate('rect').transpose();
      chart.tooltip({
        shared: true,
        showMarkers: false,
        customItems: (items) => {
          _.each(items, (item) => item.value = item.value + '%');
          return (items);
        },
      });
      chart.interaction('active-region');
      chart
        .interval()
        .adjust('stack')
        .position('city*value')
        .color('type*city', (type, city) => {
          if (type === '>=90') {
            return '#24e059';
          }
          if (type === '80-90') {
            return '#66e98b';
          }
          if (type === '60-80') {
            return '#a7f3bd';
          }
          if (type === '<60') {
            return '#e0e0e0';
          }
        })
        .size(26)
        .label('value*type', (val, t) => {
          const color = (t === '80-90' || t === '>=90') ? 'white' : '#47494b';
          if (val < 0.05) {
            return null;
          }
          return {
            position: 'middle',
            offset: 0,
            style: {
              fontSize: 12,
              fill: color,
              lineWidth: 0,
              stroke: null,
            },
            content: val
          };
        })

      this.chart8 = chart
      this.chart8.render()
    },
    superiority() {
      // 优势
      let advantageData = this.resData.superiority.advantage;
      let advantageDataTemp = []
      advantageData.forEach((item) => {
        let row = {advantage: item.name, curMonth: this.numberPercentageFormat(item.d), preMonth: this.numberPercentageFormat(item.e)}
        advantageDataTemp.push(row)
      })
      this.tableData1 = advantageDataTemp

      // 机会点
      let chanceData = this.resData.superiority.chance;
      let chanceDataTemp = []
      chanceData.forEach((item) => {
        let row = {advantage: item.checkitem, problem: item.question, curMonth: this.numberPercentageFormat(item.d), preMonth: this.numberPercentageFormat(item.e)}
        chanceDataTemp.push(row)
      })
      this.tableData2 = chanceDataTemp
    }
  }
};
</script>

<style lang="sass" scoped>
.home
  width: 100%
  min-width: 1000px
  overflow: auto

.homeBox
  padding: 20px

  .filter
    margin-top: 30px
    padding: 0 20px

  .filterBar
    padding: 0 20px

  .label
    font-size: 14px
    color: #606266

  .infoBar
    height: 50px
    width: 100%
    background-color: #E6E6E6
    margin-top: 20px
    padding: 0 40px
    line-height: 50px
    box-sizing: border-box
    box-shadow: 0 2px 3px #D5D5D5

    .rightBtn
      float: right

  .chartBox
    margin: 20px

    .title
      font-size: 14px

      .badge
        float: right
        border: 1px solid #888
        border-radius: 4px
        line-height: 24px
        padding: 0 10px

      .tag
        float: right
        line-height: 24px
        padding: 0 10px

        i
          display: inline-block
          width: 24px
          height: 24px
          border-radius: 100%
          background: #333
          color: #fff
          line-height: 24px
          text-align: center
          margin-left: 10px

    .icon
      color: #fff
      border-radius: 100%
      font-weight: 800
      display: inline-block

    .score
      text-align: center
      font-size: 14px
      height: 170px
      margin-top: 50px

      .icon
        height: 30px
        width: 30px
        line-height: 30px
        font-size: 22px
        vertical-align: 14px
        margin-left: 20px

    .curScore
      font-size: 48px
      font-weight: 500

    .preScore
      font-size: 28px
      color: #999
      margin-left: 20px

    .upIcon
      background: #67C23A

    .downIcon
      background: #808080

    .c1
      margin-top: 20px

    .bigScore
      height: 200px
      margin-top: 20px
      display: flex

      .col1
        width: 30px
        display: flex
        flex-direction: column
        font-size: 12px

        p
          height: 62px
          margin-top: 5px

      .col2, .col3, .col4
        width: calc(33% - 10px)
        display: flex
        flex-direction: column
        text-align: center

        .curData
          font-size: 20px
          font-weight: 500
          margin-bottom: 16px

        .preData
          font-size: 16px
          color: #999
          margin-top: 16px

        .type
          color: #999
          font-size: 14px
          margin-top: 16px

        .icon
          font-size: 14px
          width: 20px
          height: 20px
          line-height: 20px

      .col2, .col3
        border-right: 1px solid #dbdbdb

    .rankBox
      display: flex

      .col
        width: 25%
        align-items: center
        text-align: center
        border-right: 1px solid #ccc
        margin: 20px 0

        .iconImg
          img
            width: 60px
            height: 60px

          span
            font-size: 12px

        .rankData
          margin-top: 12px

          span.label
            font-size: 12px

          span
            font-size: 14px

          .cur, .pre
            font-size: 22px
            font-weight: 500
            margin-left: 16px
            margin-right: 16px

          .cur
            color: #67C23A

          .pre
            color: #999

          .preTotal
            color: #999

      .col:nth-last-child(1)
        border: 0

    .tableBox
      width: 100%

      .up
        color: #67C23A

      .down
        color: #999

    .c4
      overflow: auto
      margin-top: 20px
      padding-bottom: 20px

    .assessment
      display: flex
      width: 100%
      margin-top: 20px

      .leftChart
        width: 60%

      .rightChart
        width: 35%
        margin-left: 5%

        .firstLine
          font-size: 12px
          display: flex
          line-height: 26px
          height: 29px

          span
            width: 50%
            text-align: center

        .areaData
          padding: 11px 0
          height: 18px
          font-size: 14px
          font-weight: 500
          display: flex

          .curMonth
            width: 50%
            text-align: center
            align-items: center
            justify-content: center
            display: flex

            .icon
              width: 20px
              height: 20px
              line-height: 20px
              text-align: center
              margin-left: 10px

          .preMonth
            width: 50%
            text-align: center
            align-items: center
            justify-content: center

    .customerScore
      display: flex
      width: 100%
      margin-top: 20px

      .leftChart
        width: 88%

      .rightChart
        width: 7%
        margin-left: 5%

        ul
          margin: 29px 0 0 0
          padding: 0

          li
            list-style: none
            font-size: 14px
            height: 18px
            font-weight: 500
            padding: 11px 0

</style>



// WEBPACK FOOTER //
// src/opr/pages/views/HomeTotal.vue